import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie } from 'lucide-react';
export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-13">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 w-full max-w-[400px]" data-id="element-14">
          <div className="bg-[#0891b2] rounded-xl p-6 shadow-2xl border border-white/10 relative overflow-hidden" data-id="element-15">
            {/* Background Pattern */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full blur-2xl -mr-16 -mt-16 pointer-events-none" data-id="element-16"></div>

            <div className="relative z-10" data-id="element-17">
              <div className="flex items-start gap-4 mb-4" data-id="element-18">
                <div className="p-2 bg-white/10 rounded-full shrink-0" data-id="element-19">
                  <Cookie className="text-white w-6 h-6" data-id="element-20" />
                </div>
                <p className="text-white text-sm leading-relaxed font-medium" data-id="element-21">
                  We use cookies and analytics to improve your experience. By
                  accepting, you consent to analytics tracking.
                </p>
              </div>

              <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs text-white/70 mb-6 pl-[52px]" data-id="element-22">
                <a href="#" className="underline hover:text-white transition-colors" data-id="element-23">
                  Cookie Policy
                </a>
                <a href="#" className="underline hover:text-white transition-colors" data-id="element-24">
                  Privacy Notice
                </a>
              </div>

              <div className="flex gap-3 pl-[52px]" data-id="element-25">
                <button onClick={() => setIsVisible(false)} className="flex-1 py-2.5 px-4 text-sm font-bold text-white border-2 border-white/30 hover:border-white rounded-lg transition-all uppercase tracking-wide" data-id="element-26">
                  Accept
                </button>
                <button onClick={() => setIsVisible(false)} className="flex-1 py-2.5 px-4 text-sm font-bold text-[#0891b2] bg-white hover:bg-gray-100 rounded-lg transition-colors uppercase tracking-wide shadow-lg" data-id="element-27">
                  Decline
                </button>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}